import { CustomTable } from '../../../../../components';
import useTable from '../../../../../hooks/useTable.hook';
import {
  Columns,
  getJobCompletionTimeDetailsService,
} from '../../../../../services/index.service';

function JobCompletionTimeDetails({ rowData }) {

  let bookingId = rowData?.id;
  let extraQuery = {
    bookingId,
  };

  const [_, tableProps] = useTable(
    getJobCompletionTimeDetailsService,
    extraQuery,
  );
  const { data, isLoading} = tableProps;
  const columns = Columns.jobCompletionTimeDetailsColumn({
    page: 1,
    sizePerPage: 20,
  });

  return (
    <>
      <CustomTable
        tableData={data}
        pagination={false}
        tableColumns={columns}
        tableLoader={isLoading}
      />
    </>
  );
}

export default JobCompletionTimeDetails;